import React from 'react';
import {
  Badge,
  CaptionText,
  IconButton,
  v2blue600,
  V2CloseIcon,
} from '@paypalcorp/pp-react';
import { ThemeProvider } from '@paypalcorp/pp-react-theme';
import style from './badgeList.less';

const BadgeList = ({ items, onRemove }, ...props) => {
  const badges = items.map((item) => (
    <ThemeProvider theme='v2'>
      <Badge className={style.badgeStyle} type='feature'>
        <div className={style.badgeContent}>
          {item.primaryText}
          <IconButton
            className={style.removeButton}
            size='sm'
            buttonType='secondary'
            svgIconComponent={V2CloseIcon}
            onClick={function () {
              return onRemove(item);
            }}
          />
        </div>
      </Badge>
    </ThemeProvider>
  ));

  return <div>{badges}</div>;
};

export default BadgeList;
